import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import statInspsModule from "./modules/stat-insps";
import reportsModule from "./modules/reports";
import quotesModule from "./modules/quotes";
import portfolioModule from "./modules/portfolio";
import dataManagementModule from "./modules/data-management/client";
import dataManagementContractorModule from "./modules/data-management/contractors";
import userModule from "./modules/users";

Vue.use(Vuex);

const state = {
  globalClient: {},
  globalContractor: {},
  alert_variant: null,
  alert_show: false,
  alert_text: [],
  note_icons: [
    { id: 1, icon: "how_to_reg" },
    { id: 2, icon: "face" },
    { id: 3, icon: "build" }
  ],
  state: [
    { id: 1, name: "active", colour: "success" },
    { id: 2, name: "archived", colour: "warning" },
    { id: 3, name: "deleted", colour: "danger" }
  ]
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    "stat-insp": statInspsModule,
    report: reportsModule,
    quote: quotesModule,
    portfolio: portfolioModule,
    "data-management-client": dataManagementModule,
    "data-management-contractor": dataManagementContractorModule,
    user: userModule
  }
});
